import React, { useContext, useEffect, useRef, useState } from "react";
import closebutton from "../../assests/closebutton.svg";
import styles from "./ErrorReportPopup.module.css";
import _, { isEmpty } from "lodash";
import axios from "axios";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import logo from "../../assests/IssueReported.svg";
import { useParams } from "react-router";

export default function ErrorReportPopup({ setPopup }) {
  const [formDetails, setFormDetails] = useState({});
  const [errorMessage, setErrorMessage] = useState({});
  const { userIdToken, userTrackingMap, setUserTrackingMap, details } =
    useContext(Context);
  const { currentUser, newUserId, userId, loginChecker } = useUserAuth();
  const [loading, setLoading] = useState(false);
  const [errorOptions, setErrorOptions] = useState([]);
  const [reportSuccess, setReportSuccess] = useState(false);
  const token = userIdToken || currentUser?.accessToken;
  const { organizerName } = useParams();

  useEffect(() => {
    getErrorOptions();
  }, []);

  useEffect(() => {
    if (isEmpty(userId) && isEmpty(newUserId)) {
      loginChecker(token);
    }
  }, []);
  const getErrorOptions = async () => {
    try {
      let config = {
        method: "get",
        url: `https://storage.googleapis.com/goviralcampaign/errorOptions.json`,
      };
      const response = await axios(config);
      let dataFromApi = response?.data?.options;
      setErrorOptions(dataFromApi);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const buttonType = e.nativeEvent.submitter.getAttribute("type");
    if (buttonType === "submit") {
      let errors = {};
      if (_.isEmpty(formDetails?.name)) {
        errors.name = "Please enter your name";
      }
      if (_.isEmpty(formDetails?.type)) {
        errors.type = "Please select an option";
      }
      if (_.isEmpty(formDetails?.description)) {
        errors.description = "Please fill above details";
      }

      setErrorMessage(errors);
      if (_.isEmpty(errors)) {
        await errorApiCall();
      }
    }
  };

  const errorApiCall = async () => {
    setLoading(true);
    try {
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_ERROR_REPORT}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          ...formDetails,
          phoneNumber: formDetails?.phoneNumber || currentUser?.phoneNumber,
          userId: userId || newUserId,
          source: "goviral_web_app",
          userTrackingMap: userTrackingMap,
          url: window.location.href,
          email: currentUser?.email,
          campaignId: organizerName && details?._id,
          orgId: organizerName && details?.orgId,
        },
      };
      const apiResponse = await axios(config);
      if (apiResponse?.data?.status == "success") {
        setReportSuccess(true);
        setLoading(false);
        setUserTrackingMap([]);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormDetails((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };
  return (
    <>
      <div
        className={`fixed top-0 left-0 h-[100%] w-[100%] flex items-center justify-center z-10 px-[20px] ${styles.popupBackground} overflow-y-auto no-scrollbar z-[100]`}
      >
        {reportSuccess ? (
          <div className={styles.container}>
            <img src={logo} alt="" className="w-[56px] h-[56px] mb-[24px]  " />
            <pre className="text-small text-[#CDCDCD] px-[20px] text-center">
              Your concern has been conveyed to our team, we’ll sort it out
              right away!
            </pre>
            <div className="seperator my-[20px]" />
            <div className="flex flex-col gap-[16px] w-[100%] cursor-pointer">
              <button
                className={`text-regular-medium ${styles.button}`}
                onClick={() => setPopup(false)}
              >
                Ok
              </button>
            </div>
          </div>
        ) : (
          <div className=" absolute top-0">
            <div className={`${styles.popupParent}`}>
              <div className="relative w-[100%]">
                <div className="flex justify-between items-center w-[100%] pt-[20px] px-[20px]">
                  <p className="text-regular-bold text-[#CDCDCD]">
                    Raise an issue
                  </p>
                  <img
                    src={closebutton}
                    onClick={() => setPopup(false)}
                    className=" hover:cursor-pointer"
                  />
                </div>
                <form className={styles.claimForm} onSubmit={handleSubmit}>
                  <div className="flex flex-col gap-[10px] mt-[20px]">
                    <label className="text-regular ">
                      Issue Type <span className="text-[#FA6B6B]">*</span>
                    </label>
                    <select
                      onChange={(e) => {
                        setFormDetails({
                          ...formDetails,
                          type: JSON.parse(e.target.value)?.errorType,
                        });
                      }}
                      className=""
                    >
                      <option selected disabled>
                        Select an issue type
                      </option>
                      {errorOptions?.map((el) => {
                        return (
                          <>
                            <option className="" value={JSON.stringify(el)}>
                              {el?.description}
                            </option>
                          </>
                        );
                      })}
                    </select>
                    {errorMessage?.type && (
                      <p className="text-[#FA6B6B] text-smallest ">
                        {errorMessage?.type}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                    <label htmlFor="name">
                      Name
                      <span className="text-[#FA6B6B]">*</span>{" "}
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        maxlength="250"
                        value={formDetails.name}
                        onChange={handleInputChange}
                        className={`no-scrollbar ${
                          errorMessage?.name && styles.error
                        }`}
                      />
                    </div>
                    {errorMessage?.name && (
                      <p className="text-[#FA6B6B] text-smallest ">
                        {errorMessage?.name}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                    <div>
                      <label htmlFor="name">Phone Number</label>
                      <p className="text-[#B5B5B5]  text-smallest">
                        Share your mobile number for quick resolution
                      </p>
                    </div>
                    <div className="relative">
                      <input
                        type="text"
                        id="phoneNumber"
                        name="phoneNumber"
                        value={formDetails.phoneNumber}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-[10px] mt-[30px] text-regular">
                    <label htmlFor="description">
                      Describe the Issue{" "}
                      <span className="text-[#FA6B6B]">*</span>{" "}
                    </label>
                    <div className="relative">
                      <textarea
                        type="text"
                        id="description"
                        name="description"
                        maxlength="250"
                        value={formDetails.description}
                        placeholder="Explain the issue briefly, e.g., log-in not completed, technical glitches affecting submissions."
                        onChange={handleInputChange}
                        className={`no-scrollbar ${
                          errorMessage?.description && styles.error
                        }`}
                      />
                      <span className="text-white w-[98%] absolute flex bottom-2 justify-end opacity-[.6]">
                        {formDetails?.description
                          ? formDetails?.description?.length
                          : 0}
                        /250
                      </span>
                    </div>
                    {errorMessage?.description && (
                      <p className="text-[#FA6B6B] text-smallest ">
                        {errorMessage?.description}
                      </p>
                    )}
                  </div>
                  <div className="w-full mt-[16px] flex">
                    <button
                      type="submit"
                      className="ml-auto w-fit drop-shadow px-[12px] py-[5px] bg-[#262626] text-[#f6f6f6] rounded-[10px] text-regular"
                      disabled={loading}
                    >
                      {loading ? "Loading" : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
